import type { UiRoot } from "../ui/UiRoot";
import type { Scene } from "./Scene";

export class PlayScene implements Scene {
  readonly id = "play" as const;
  constructor(private readonly ui: UiRoot) {}
  enter(): void {
    this.ui.show("none");
  }
  exit(): void {}
}
